import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "../../imports/muiImport";

import { useLocation, useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import ProductCardsList from "./LARGEDEVICE/ProductCardsList";
import { getAllProducts, useSelector } from "../../imports/generalImport";
import CursorPagination from "../../components/pagination/CursorPagination";


import ProductFilterMobile from "./MEDIUMDEVICE/mobileProductFilter";

const MobileAllGiftCardPage = () => {
  const categories = useSelector(
    (state) => state?.Dashboard?.categories
  );
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const searchItem = useLocation();
  const canonicalUrl = `https://www.99gift.ae/${searchItem.pathname}`;

  const categoryIds =
    searchParams.get("categoryIds[]")?.split(",") || [];

  // Fetch Products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);

        const payload = {
          categoryIds,
          limit: 8,
        };

        if (categoryIds.length > 0) {
          payload.categoryIds = categoryIds;
        }

        const response = await getAllProducts(payload);

        if (response?.success) {
          setProducts(response?.data?.edges || []);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [searchParams]);

  const pageTitle =
    categoryIds.length > 0
      ? categories
        ?.filter((cat) =>
          categoryIds.includes(String(cat?.id))
        )
        .map((cat) => cat.name)
        .join(", ")
      : "All Gift Cards";

  return (
    <>
      <Helmet>
        <title>Explore the Best Gift Cards</title>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>

      {/* Products */}
      <Container
        maxWidth="xl"
        sx={{
          px: {
            xs: 0,
            sm: 2,
            md: 0,
          },
        }}
      >
        {/* MOBILE CATEGORY SLIDER */}
        <Box
          sx={{
            display: {
              xs: "block",
              sm: "block",
              md: "none",
            },
            overflowX: "auto",
            whiteSpace: "nowrap",
            "&::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <ProductFilterMobile
            categoryIds={categoryIds}
            setSearchParams={setSearchParams}
          />
        </Box>

        <Grid container spacing={3} id="target-section">
          {/* Product List */}
          <Grid item xs sx={{
            borderLeft: {
              xs: "none",
              md: "2px solid #E4C18F",
            },
          }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: {
                  xs: 2,
                  sm: 4,
                },
                mt: {
                  xs: 1,
                  sm: 2,
                },
                mr: {
                  xs: 0,
                  sm: 2,
                  md: 3,
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: {
                    xs: "20px",
                    sm: "24px",
                    md: "30px",
                  },
                  color: "primary.main",
                  fontFamily: "Onest",
                  lineHeight: 1.2,
                }}
              >
                {pageTitle}
              </Typography>
            </Box>

            <ProductCardsList products={products} loading={loading} />

            <CursorPagination
              fetchFunction={getAllProducts}
              limit={8}
              basePayload={{
                categoryIds,
              }}
              dependency={[searchParams]}
              onDataChange={(data) =>
                setProducts(data)
              }
              responseMapper={(response) => ({
                data: response?.data?.edges,
                totalCount: response?.data?.totalCount,
                hasNextPage: response.data?.pageInfo?.hasNextPage,
                endCursor: response.data?.pageInfo?.endCursor,
              })}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default MobileAllGiftCardPage;